import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ElectricmeterComponent } from './electricmeter.component';
import { ElectricmeterDetailComponent } from './electricmeter-detail.component';
import { ElectricmeterPopupComponent } from './electricmeter-dialog.component';
import { ElectricmeterDeletePopupComponent } from './electricmeter-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class ElectricmeterResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const electricmeterRoute: Routes = [
  {
    path: 'electricmeter',
    component: ElectricmeterComponent,
    resolve: {
      'pagingParams': ElectricmeterResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.electricmeter.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'electricmeter/:id',
    component: ElectricmeterDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.electricmeter.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const electricmeterPopupRoute: Routes = [
  {
    path: 'electricmeter-new',
    component: ElectricmeterPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.electricmeter.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'electricmeter/:id/edit',
    component: ElectricmeterPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.electricmeter.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'electricmeter/:id/delete',
    component: ElectricmeterDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.electricmeter.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/electricmeter/electricmeter.route.ts